import { sortAlphabeticallyByKey } from '@fortem-monorepo/js-utilities'

export const FUNDING_RETURN_TYPES = ['TR', 'ER'] as const
export const FUNDED_RETURN_TYPES = ['TR', 'PR'] as const

const ALL_RETURN_TYPES = [...FUNDING_RETURN_TYPES, ...FUNDED_RETURN_TYPES]

export type FundingReturnType = (typeof FUNDING_RETURN_TYPES)[number]
export type FundedReturnType = (typeof FUNDED_RETURN_TYPES)[number]
export type ReturnType = (typeof ALL_RETURN_TYPES)[number]

export const RETURN_TYPE_LABELS: Record<ReturnType, string> = {
  TR: 'Total Return',
  ER: 'Excess Return',
  PR: 'Price Return',
}

export const FUNDING_RETURN_TYPE_OPTIONS = sortAlphabeticallyByKey(
  FUNDING_RETURN_TYPES.map((i) => ({
    label: RETURN_TYPE_LABELS[i],
    value: i,
  })),
  'label',
)

export const FUNDED_RETURN_TYPE_OPTIONS = sortAlphabeticallyByKey(
  FUNDED_RETURN_TYPES.map((i) => ({
    label: RETURN_TYPE_LABELS[i],
    value: i,
  })),
  'label',
)
